module.exports = __webpack_public_path__ + "src/assets/img/ssp.b5736314.jpg";